var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count > 0)?_c('indicator',[_c('alert2-icon',{attrs:{"level":_vm.level,"size":_vm.size,"content":_vm.content}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }